import React, { useEffect, useState, useCallback } from 'react';
import { Currency } from 'shared/components/Transactions/components';
import { ProjectBillingStatusDetail } from '../../constants';
import ProjectCount from './ProjectCount';
import { formatNumberWithFixedDecimals } from 'app/Portal/Billing/utilities/UtilityFunctions';

const InvoicingTotals = ({
  results,
  totalAllocationCost,
  totalUtilityCredit,
  totalAllocationAmount,
  totalInvoiceCount,
  successfullyGeneratedInvoiceCount,
  canGenerate,
  canFinalize,
  invoicedBeforeLaunchDate
}) => {
  const [projects, setProjects] = useState({
    totalProjects: [],
    projectsReferenceActive: [],
    projectsReferenceRemoved: []
  });
  const projectBreakdown = useCallback(results => {
    const projectDetails = results?.reduce((accumulator, item) => {
      return accumulator.concat(item.projectDetails);
    }, []);

    const projectsReferenceActive = projectDetails.filter(
      project => project.status === ProjectBillingStatusDetail.InAnotherBillingForGivenPeriod
    );
    const projectsReferenceRemoved = projectDetails.filter(
      project => project.status === ProjectBillingStatusDetail.OtherBillingReferenceRemoved
    );

    setProjects({ totalProjects: projectDetails, projectsReferenceActive, projectsReferenceRemoved });
  }, []);

  useEffect(() => {
    projectBreakdown(results);
  }, [results, projectBreakdown]);

  const showTotals =
    !invoicedBeforeLaunchDate &&
    !canGenerate &&
    (!canFinalize || totalInvoiceCount === successfullyGeneratedInvoiceCount) &&
    totalInvoiceCount !== 0;

  return (
    <div className="totals-grid">
      <div>
        <div className="totals-label">Subscribers</div>
        <div className="totals-value">{results.length}</div>
      </div>
      <div className="shift-right">
        <div className="totals-label text-right">Line items</div>
        <div className="totals-value text-right" style={{ whiteSpace: 'nowrap' }}>
          {projects.totalProjects.length}
          {projects?.projectsReferenceActive?.length >= 1 || projects?.projectsReferenceRemoved?.length >= 1 ? (
            <ProjectCount
              projectsReferenceActive={projects?.projectsReferenceActive?.length}
              projectsReferenceRemoved={projects?.projectsReferenceRemoved?.length}
            />
          ) : null}
        </div>
      </div>
      <div className="shift-right">
        <div className="totals-label text-right">Total Invoices</div>
        <div className="totals-value text-right">{showTotals ? <Currency amount={totalAllocationCost} /> : '--'}</div>
      </div>
      <div className="shift-right">
        <div className="totals-label text-right">Total Utility Credit</div>
        <div className="totals-value text-right">{showTotals ? <Currency amount={totalUtilityCredit} /> : '--'}</div>
      </div>
      <div className="shift-right">
        <div className="totals-label text-right">Total Allocation (kWh)</div>
        <div className="totals-value text-right">{showTotals ? formatNumberWithFixedDecimals(totalAllocationAmount, 4) : '--'}</div>
      </div>
      <div />
    </div>
  );
};

export default InvoicingTotals;
